import { observer } from "mobx-react-lite";
import React, { Fragment } from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import { Button, Grid, Segment, Tab } from "semantic-ui-react";
import AnswerList from "./answers/AnswerList";
import Comments from "./comments/Comments";
import QuestionForm from "./form/QuestionForm";
import ImageList from "./images/ImageList";
import QuestionStatisticsDashboard from "./statistics/QuestionStatisticsDashboard";

interface DetailParams {
  id: string;
}

const QuestionItem: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
}) => {
  const panes = [
    {
      menuItem: "Questāo",
      render: () => (
        <Tab.Pane>
          <QuestionForm id={match.params.id} />
        </Tab.Pane>
      ),
    },
  ];

  if (match.params.id) {
    const imagesTab = {
      menuItem: "Imagens",
      render: () => (
        <Tab.Pane>
          <ImageList questionId={match.params.id} />
        </Tab.Pane>
      ),
    };
    const answersTab = {
      menuItem: "Respostas",
      render: () => (
        <Tab.Pane>
          <AnswerList questionId={match.params.id} />
        </Tab.Pane>
      ),
    };
    const commentsTab = {
      menuItem: "Comentários",
      render: () => (
        <Tab.Pane>
          <Comments questionId={match.params.id} />
        </Tab.Pane>
      ),
    };
    const statisticsTab = {
      menuItem: "Estatísticas",
      render: () => (
        <Tab.Pane>
          <QuestionStatisticsDashboard />
        </Tab.Pane>
      ),
    };
    panes.push(imagesTab);
    panes.push(answersTab);
    panes.push(commentsTab);
    panes.push(statisticsTab);
  }

  return (
    <Fragment>
      <Grid>
        <Grid.Column width={14}>
          {match.params.id ? <h1>Editar Questāo</h1> : <h1>Nova Questāo</h1>}
        </Grid.Column>
        <Grid.Column width={2}>
          {match.params.id && (
            <Button
              as={Link}
              to="/admin/novaquestao"
              active
              positive
              content="Nova"
              floated="right"
              style={{ marginTop: "12px" }}
            />
          )}
        </Grid.Column>
      </Grid>
      <Segment clearing>
        <Tab panes={panes} />
      </Segment>
    </Fragment>
  );
};

export default observer(QuestionItem);
